import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  InputNumber,
  Button,
  Drawer,
  Table,
  Divider,
  Row,
  Col,
  Space,
  Popconfirm,
  Radio,
} from "antd";

import { EditOutlined, DeleteOutlined } from "@ant-design/icons";

import { create as CreateCareUnit } from "../../api/CareUnit.js";
import { update as UpdateCareUnit } from "../../api/CareUnit.js";
import { all as AllCareUnitDatesRange } from "../../api/CareUnitDatesRange";
import { getOne as GetCareUnitDatesRange } from "../../api/CareUnitDatesRange";
import { remove as DeleteCareUnitDatesRange } from "../../api/CareUnitDatesRange";

import CareUnitDatesRangeForm from "./CareUnitDatesRangeForm.js";

import moment from "moment";

const { TextArea } = Input;

const layout = {
  labelCol: {
    span: 7,
  },
  wrapperCol: {
    span: 18,
    className: "mx-3",
  },
};

/**
 *
 * @param {*} props
 * @returns
 */
const CareUnitForm = (props) => {
  const { careUnit } = props;

  const [visible, setVisible] = useState(false);
  const [visibleCareUnitDatesRange, setVisibleCareUnitDatesRange] =
    useState(false);
  const [selectedCareUnitDatesRange, setSelectedCareUnitDatesRange] =
    useState(null);
  const [careUniteDatesRanges, setCareUniteDatesRanges] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 5,
    showSizeChanger: true,
    position: ["topRight"],
  });

  const [form] = Form.useForm();

  let initialValues = {
    name: null,
    description: null,
    daily_bed_capacity: 45,
    daily_occupancy_rate: 25,
    care_plan_switch_hour: 16,
    allowed_sending_mails: true
  };

  useEffect(() => {
    if (careUnit) {
      form.setFieldsValue({
        name: careUnit.name,
        description: careUnit.description,
        daily_bed_capacity: careUnit.daily_bed_capacity,
        daily_occupancy_rate: careUnit.daily_occupancy_rate,
        care_plan_switch_hour: careUnit.care_plan_switch_hour,
        allowed_sending_mails: careUnit.allowed_sending_mails,
      });
    }
  }, [careUnit]);

  useEffect(() => {
    setVisible(props.visible);

    if (careUnit) {
      fetchCareUniteDatesRanges(pagination);
    }
  }, [props.visible]);

  /**
   *
   */
  const onFinish = async () => {
    form.validateFields().then(async (values) => {
      if (careUnit) {
        await UpdateCareUnit(careUnit.id, values);
      } else {
        await CreateCareUnit(values);
      }

      props.onCreated();
      onClose();
    });
  };

  /**
   *
   * @param {*} errorInfo
   */
  const onFinishFailed = (errorInfo) => {
    // @todo a implementé
    console.log("Failed:", errorInfo);
  };

  /**
   *
   */
  const onClose = () => {
    setCareUniteDatesRanges([]);
    form.resetFields();
    props.onClose();
  };

  /**
   *
   */
  const onCloseCareUnitDatesRangeForm = () => {
    setVisibleCareUnitDatesRange(false);
    setSelectedCareUnitDatesRange(null);
    fetchCareUniteDatesRanges(pagination);
  };

  let getParams = (pagination, sorter) => {
    let params = {
      current: pagination.current,
      pageSize: pagination.pageSize,
    };

    if (sorter !== undefined && sorter.column !== undefined) {
      let { field, order } = sorter;
      order = order === "ascend" ? 1 : -1;

      if (!!field && !!order) {
        params["sort"] = field + "," + order;
      }
    }

    return params;
  };

  /**
   *
   * @param {*} pagination
   * @param {*} filters
   * @param {*} sorter
   */
  let fetchCareUniteDatesRanges = async function (pagination, filters, sorter) {
    let params = getParams(pagination, sorter);
    params["q"] = {
      care_unit_id: careUnit.id,
    };

    AllCareUnitDatesRange(params).then((data) => {
      setCareUniteDatesRanges(data.results);
      setPagination({
        ...pagination,
        total: data.total,
      });
    });
  };

  /**
   *
   */
  const showCareUnitDatesRangeForm = () => {
    setVisibleCareUnitDatesRange(true);
  };

  /**
   *
   * @param {*} careUnitDatedRangeId
   */
  const editCareUnitDatesRangeHandler = async (careUnitDatedRangeId) => {
    let careUnitDatesRange = await GetCareUnitDatesRange(careUnitDatedRangeId);
    setSelectedCareUnitDatesRange(careUnitDatesRange);
    setVisibleCareUnitDatesRange(true);
  };

  /**
   *
   * @param {*} careUnitDatedRangeId
   */
  const deleteCareUnitDatesRangeHandler = async (careUnitDatedRangeId) => {
    await DeleteCareUnitDatesRange(careUnitDatedRangeId);
    fetchCareUniteDatesRanges(pagination);
  };

  let drawerTitle = "Ajout d'une nouvelle unité";
  if (careUnit) {
    drawerTitle = "Modification d'une unité";
  }

  let careUnitDatesRangesTable = null;

  if (careUnit) {
    careUnitDatesRangesTable = (
      <div>
        <Row
          style={{
            textAlign: "right",
          }}
        >
          <Col span={24}>
            <Button
              key="add"
              type="primary"
              size="large"
              onClick={showCareUnitDatesRangeForm}
              style={{
                marginBottom: "20px",
              }}
            >
              Ajout d'une nouvelle date
            </Button>
          </Col>
        </Row>
        <Table
          columns={[
            {
              title: "Dates",
              width: "20%",
              render: (data) => {
                if (data.start_at === data.end_at) {
                  return (
                    <div>{moment(data.start_at).format("DD/MM/YYYY")}</div>
                  );
                } else {
                  return (
                    <div>
                      {moment(data.start_at).format("DD/MM/YYYY")} =>{" "}
                      {moment(data.end_at).format("DD/MM/YYYY")}
                    </div>
                  );
                }
              },
            },
            {
              title: "Nombre de lits",
              dataIndex: "daily_bed_capacity",
              align: "right",
              width: "20%",
            },
            {
              title: "Taux d'occupation non-programmée anticipé",
              dataIndex: "daily_occupancy_rate",
              align: "right",
              render: (data) => {
                return data + "%";
              },
            },
            {
              render: (data) => {
                return (
                  <Space>
                    <Button
                      disabled={
                        moment(data.start_at).startOf("day") <
                        moment().startOf("day")
                      }
                      type="primary"
                      shape="circle"
                      icon={<EditOutlined />}
                      size="large"
                      onClick={() => {
                        editCareUnitDatesRangeHandler(data.id);
                      }}
                    ></Button>
                    <Popconfirm
                      placement="top"
                      title={"Confirmez-vous la suppression ?"}
                      onConfirm={() => {
                        deleteCareUnitDatesRangeHandler(data.id);
                      }}
                      okText="Oui"
                      cancelText="Non"
                      disabled={
                        moment(data.start_at).startOf("day") <
                        moment().startOf("day")
                      }
                    >
                      <Button
                        disabled={
                          moment(data.start_at).startOf("day") <
                          moment().startOf("day")
                        }
                        danger
                        type="primary"
                        shape="circle"
                        icon={<DeleteOutlined />}
                        size="large"
                      ></Button>
                    </Popconfirm>
                  </Space>
                );
              },
              width: "30px",
            },
          ]}
          pagination={pagination}
          dataSource={careUniteDatesRanges}
          onChange={fetchCareUniteDatesRanges}
        />
      </div>
    );
  }

  return (
    <Drawer
      title={drawerTitle}
      placement="left"
      closable={true}
      onClose={onClose}
      visible={visible}
      width="800px"
      key="left"
      footer={
        <div
          style={{
            textAlign: "right",
          }}
        >
          <Button onClick={onClose} style={{ marginRight: 8 }}>
            Annuler
          </Button>
          <Button onClick={onFinish} type="primary">
            Enregistrer
          </Button>
        </div>
      }
    >
      <Form
        {...layout}
        form={form}
        name="care_unit"
        initialValues={initialValues}
        onFinishFailed={onFinishFailed}
      >
        <Form.Item
          label="Nom"
          name="name"
          rules={[
            {
              required: true,
              message: "Champs obligatoire",
            },
          ]}
        >
          <Input className="ant-input-text" />
        </Form.Item>
        <Form.Item label="Description" name="description">
          <TextArea rows={4} className="ant-input-text" />
        </Form.Item>
        <Form.Item
          label="Nombre de lits"
          name="daily_bed_capacity"
          rules={[
            {
              required: true,
              message: "Champs obligatoire",
            },
          ]}
        >
          <InputNumber style={{ padding: 2 }} />
        </Form.Item>
        <Form.Item
          label={
              <span>
                Taux d'occupation
                <br />
                non-programmée anticipé
              </span>
          }
          name="daily_occupancy_rate"
          rules={[
            {
              required: true,
              message: "Champs obligatoire",
            },
          ]}
          style={{ minHeight: 35 }}
        >
          <InputNumber
            style={{ padding: 2 }}
            formatter={(value) => `${value}%`}
            parser={(value) => value.replace("%", "")}
          />
        </Form.Item>
        <Form.Item
          label="Horaire de bascule"
          name="care_plan_switch_hour"
          tooltip="Pour les jours d'affectation des soins"
          rules={[
            {
              required: true,
              message: "Champs obligatoire",
            },
          ]}
        >
          <InputNumber
            style={{ padding: 2 }}
            min={1}
            max={23}
            step={1}
            formatter={(value) => `${value}h`}
            parser={(value) => value.replace("h", "")}
          />
        </Form.Item>

        <Form.Item label="Envoi des mails aux cadres" name="allowed_sending_mails">
          <Radio.Group >
            <Radio value={true}>Oui</Radio>
            <Radio value={false}>Non</Radio>
          </Radio.Group>
        </Form.Item>
      </Form>

      <Divider />

      {careUnitDatesRangesTable}

      <CareUnitDatesRangeForm
        careUnit={careUnit}
        careUnitDatesRange={selectedCareUnitDatesRange}
        onClose={onCloseCareUnitDatesRangeForm}
        onCreated={() => {}}
        visible={visibleCareUnitDatesRange}
      />
    </Drawer>
  );
};

export default CareUnitForm;
